import React, { JSX } from 'react';
import { Box, Button, HStack, Image, Text, VStack } from '@chakra-ui/react';

import { RestaurantSelect } from '../../../../../common/components/RestaurantSelect/RestaurantSelect';
import { SelectOption } from '../../../../../common/components/Select/model/selectOption';
import Step from '../../../../../common/components/Stepper/Step';
import Stepper from '../../../../../common/components/Stepper/Stepper';
import { useTranslations } from '../../../../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../../../../contexts/ScannedRelevosContext';
import { useRestaurantsData } from '../../../../../services/restaurants';
import colors from '../../../../../styles/colors';
import { UserSelectMode } from '../../../components/UserSelect/types';
import { getAssignSelectStyle } from '../../../styles/relevo-assign-select-style';

type RelevosStepsDefaultProps = {
  firstStep: string;
  firstStepDescription: string;
  secondStep: string | JSX.Element;
  secondStepDescription?: string;
  isUpgrade: boolean;
  mode: UserSelectMode;
};

const RelevosSteps = ({ ...props }: RelevosStepsDefaultProps): JSX.Element | null => {
  const {
    applicationUser,
    quickContact,
    restaurant,
    setQuickContact,
    restaurantId,
    setRestaurantId,
    resetRestaurantId,
  } = useScannedRelevosContext();
  const { restaurantIds, restaurants } = useRestaurantsData();
  const translations = useTranslations();

  const handleClearRestaurant = () => {
    resetRestaurantId();
    setQuickContact(null);
  };

  const getIconPath = (iconName: string) => require(`../../../../../assets/icons/${iconName}`);

  return (
    <HStack align="stretch" w={'100%'}>
      <Stepper activeIndex={!restaurantId ? 0 : 1} width={'100%'} height={150}>
        <Step index={0}>
          <VStack align="start" spacing="0px" w={'100%'}>
            <HStack align="start" spacing="0px">
              <VStack align="start" textAlign="left" spacing="0px" ml={2}>
                <Text color={!applicationUser && !quickContact ? colors.grey[900] : colors.grey[100]} fontWeight="bold">
                  {props.firstStep}
                </Text>
                <Text color={!applicationUser && !quickContact ? colors.grey[900] : colors.grey[100]}>
                  {props.firstStepDescription}
                </Text>
              </VStack>
            </HStack>

            {!restaurantId ? (
              <Box w={['100%', '100%', '50%', '50%']} px={2} py={[1, 1, 2, 2]}>
                <RestaurantSelect
                  userRestaurants={restaurants}
                  restaurantId={restaurantId}
                  setRestaurantId={setRestaurantId}
                  resetRestaurantId={resetRestaurantId}
                  styles={getAssignSelectStyle<SelectOption>()}
                />
              </Box>
            ) : null}

            <HStack style={!restaurantId ? { display: 'none' } : {}}>
              <Image src={getIconPath('done.svg')} alt={'Done icon'} mr={2} />
              <Text color={restaurantId ? colors.grey[900] : colors.beige[50]} textAlign="left" fontSize="18px">
                {translations('restaurant')} <b>{restaurants.find((r) => r.id === restaurantId)?.restaurantName}</b>
              </Text>
              {restaurantIds.length > 1 ? (
                <Button variant={'transparent'} color={colors.orange[500]} onClick={handleClearRestaurant}>
                  {translations('change')}
                </Button>
              ) : null}
            </HStack>
          </VStack>
        </Step>

        <Step index={1}>
          <VStack
            alignItems="start"
            textAlign="left"
            display={'flex'}
            spacing="0px"
            my={'auto'}
            ml={2}
            mb={props.secondStepDescription && restaurantId ? -6 : 0}
          >
            <Text color={restaurant ? colors.grey[900] : colors.grey[100]} fontWeight="bold">
              {props.secondStep}
            </Text>
            {props.secondStepDescription && restaurantId ? (
              <Box color={restaurant ? colors.grey[900] : colors.grey[100]}>{props.secondStepDescription}</Box>
            ) : null}
          </VStack>
        </Step>
      </Stepper>
    </HStack>
  );
};
export default RelevosSteps;
